import { render, staticRenderFns } from "./MatomoConsentBanner.vue?vue&type=template&id=73c5e7bc&scoped=true&"
import script from "./MatomoConsentBanner.vue?vue&type=script&lang=js&"
export * from "./MatomoConsentBanner.vue?vue&type=script&lang=js&"
import style0 from "./MatomoConsentBanner.vue?vue&type=style&index=0&id=73c5e7bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c5e7bc",
  null
  
)

export default component.exports